import { useEffect } from "react";

export default function HeartsLayer() {

  useEffect(() => { // Create a heart element every 300ms with random horizontal position, and remove it after 5 seconds

    const interval = setInterval(() => {

      const heart = document.createElement("div");
      heart.className = "heart";
      heart.innerText = "❤️";

      heart.style.left = Math.random() * 100 + "vw";

      document.body.appendChild(heart);

      setTimeout(() => heart.remove(), 5000);

    }, 300);

    return () => clearInterval(interval);

  }, []);

  return null;

}